// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"01f25925","367":"f176da67","453":"d8e2a990","551":"ae78fb54","640":"65281bf4","828":"b7c587d4"}[chunkId] + ".chunk.js";
};